import { EditorNode, EditorTree } from './tree';

/**
 * Types related to tree organization and layout
 */

/**
 * Mode for tree organization (automatic or manual)
 */
export type OrganizationMode = 'manual' | 'auto' | 'cluster';

/**
 * Direction for tree organization (vertical or horizontal)
 */
export enum OrganizationDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

/**
 * Arguments for organizing a tree
 */
export interface OrganizeTreeArgs {
  direction: OrganizationDirection;
  mode?: OrganizationMode;
  tree: EditorTree;
  visualizationDimensions: { width: number; height: number };
  selectedNode?: EditorNode | null;
}